/* eslint-disable class-methods-use-this */
export interface DiscoveryDocumentCache {
  get: Storage['getItem'];
  set: Storage['setItem'];
}

export class LocalStorageCache implements DiscoveryDocumentCache {
  get(key: string) {
    return window.localStorage.getItem(key);
  }

  set(key: string, item: string) {
    window.localStorage.setItem(key, item);
  }
}
